/**
 * অবস্থা ১০ · সেবা সাময়িক বন্ধ — `E_SERVICE_PAUSED`.
 *
 * NO FRAME IS DRAWN FOR THIS STATE.
 *
 * It is row 9 of the applicability matrix in `design/Oprappo P0 States.dc.html`
 * (line 761), `হ্যাঁ` on আবিষ্কার, এআই, লেনদেন and অভ্যন্তরীণ — four cells — and it is
 * a chip in `design/Oprappo Architecture.dc.html § 15 · Required states, every P0
 * screen` (line 908), under the heading "none of them may be left undefined". Both
 * places name it; neither draws it, and a search of all fifteen `.dc.html` files finds
 * the string in exactly those two places.
 *
 * WHAT THIS COMPONENT THEREFORE DOES NOT DO: write a headline, write an explanation,
 * pick an icon, or choose an action label. docs/01 § prohibited is unambiguous —
 * "Invent copy … Missing strings: ask" — and four cells of matrix are not a licence to
 * draft Bangla. The heading is the matrix row label, which is a drawn string; the body
 * is `message_bn` from the error envelope, which docs/05 § conventions already makes
 * the source of every user-facing sentence.
 *
 * WHAT IS NEEDED TO FINISH IT: one drawn frame, or the four rules applied by a
 * designer — a paused service has to say what is paused, until when, and what still
 * works, the same three things § ৯ says for a pending verification. Reported.
 */
import { UndrawnPanel } from './chrome.js';
import { STATE_LABEL_BN } from './keys.js';

export interface ServicePausedStateProps {
  /**
   * `error.message_bn`, already localised. REQUIRED: with no drawn copy, a body this
   * component could fall back to would be a body it invented.
   */
  messageBn: string;
  onBack?: (() => void) | undefined;
}

export function ServicePausedState({ messageBn, onBack }: ServicePausedStateProps): JSX.Element {
  return (
    <UndrawnPanel
      stateKey="service_paused"
      headingBn={STATE_LABEL_BN.service_paused}
      messageBn={messageBn}
      onBack={onBack}
    />
  );
}
